
























































import { Component, Vue } from 'vue-property-decorator'
import { foodStore, VendorFoodCreate } from '../store/food-store'

@Component
export default class FoodListPage extends Vue {
  newFoodTitle = ''
  newFoodDescription = ''
  newFoodPrice = '0.00'

  get foodList () {
    return foodStore.foodList
  }

  openNewFoodPopup () {
    this.clearForm()

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.$f7!.popup.open('#new-food-popup')
  }

  private clearForm () {
    this.newFoodTitle = ''
    this.newFoodDescription = ''
    this.newFoodPrice = '0.00'
  }

  async addNewFood (newFoodTitle: string, newFoodDescription: string, newFoodPrice: string) {
    const newFood: VendorFoodCreate = {
      title: newFoodTitle,
      description: newFoodDescription,
      price: newFoodPrice
    }

    await foodStore.addFood(newFood)

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.$f7!.popup.close('#new-food-popup')
    this.clearForm()
  }
}
